import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { PartsBusinessService } from '../../business-services/parts.service';

@Injectable({ providedIn: 'root' })
export class EditPartsServiceGuard  {

  constructor(
    private partService: PartsBusinessService,
    private router: Router
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.partService.partId) {
      return true;
    }
    return this.router.createUrlTree(['/parts']);
  }
}
